import React from "react";
import { Radio } from "lucide-react";

export function Logo({ size = 22, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div
        className="rv-gradient flex items-center justify-center rounded-xl text-white shadow-lg"
        style={{ width: size + 16, height: size + 16, boxShadow: "0 8px 24px rgba(139,92,246,0.35)" }}
      >
        <Radio size={size} strokeWidth={2.4} />
      </div>
      {showText && (
        <div className="leading-none">
          <div className="font-extrabold tracking-wide rv-gradient-text" style={{ fontSize: size }}>
            RadioVerse
          </div>
          <div className="text-rv-muted uppercase font-bold" style={{ fontSize: 8, letterSpacing: 2.5 }}>
            MediaVerse Labs
          </div>
        </div>
      )}
    </div>
  );
}
